<template>
  <div>
    <qc-dialog class="tc-15-rich-dialog cos editor-dialog" ref="editorDialog" :show="innerShow" type="custom"
      :default-cancel="false" :no-close-button="true" :width="editorRect.width" @close="closeDialog"
      :closeTriggers="[]">
      <div slot="title">
        <div class="header">
          <div class="title">
            <div class="title-text" :title="fileInfo && fileInfo.key">{{$t('core.edit')}} {{fileInfo && fileInfo.key}}
            </div>
            <div class="title-tips">
              <span class="writing" v-show="writing">{{$t('core.edit_saving')}}...</span>
              <span class="unsaved" v-show="!writing && unsaved">[{{$t('core.edit_unsaved')}}]</span>
            </div>
          </div>

          <div class="toolbar">
            <div class="history">
              <qc-bubble placement="top" type="dark" popup-class="history-bubble-index">
                <a href="javascript:;" @click="onEditorHistory"><i class="cos-icon--16 editor-history"></i></a>
                <template slot="popup">{{$t('core.editor_history')}}</template>
              </qc-bubble>
            </div>
            <div class="setting">
              <qc-dropdown type="button" trigger="click" class="editor-option editor-double-dropdown" :closeOnClick="true" min-width="180px"
                max-height="300px">
                {{CHARSET[charset]&&CHARSET[charset].labelShort || charset}}
                <template slot="dropdown">

                  <qc-dropdown-item v-for="charsetName in saveCharset" :key="charsetName"
                    @click="openWithCharset(charsetName)">
                    {{$t('core.open_with_encode_param',{encode: CHARSET[charsetName].labelShort})}}
                  </qc-dropdown-item>
                  <qc-dropdown-item>
                    {{$t('core.open_with_other_encode')}}
                    <template slot="dropdown">
                      <qc-dropdown-item v-for="(charsetItem,charsetName) in CHARSET" :key="charsetName"
                        @click="openWithCharset(charsetName)">
                        {{$t('core.open_with_encode_param',{encode: charsetItem.labelShort})}}
                      </qc-dropdown-item>
                    </template>
                  </qc-dropdown-item>

                  <qc-dropdown-item v-for="charsetName in saveCharset" :key="charsetName"
                    @click="saveWithCharset(charsetName)">
                    {{$t('core.convert_to_encode_param',{encode: CHARSET[charsetName].labelShort})}}
                  </qc-dropdown-item>
                  <qc-dropdown-item>
                    {{$t('core.convert_to_other_encode')}}
                    <template slot="dropdown">
                      <qc-dropdown-item v-for="(charsetItem,charsetName) in CHARSET" :key="charsetName"
                        @click="saveWithCharset(charsetName)">
                        {{$t('core.convert_to_encode_param',{encode: charsetItem.labelShort})}}
                      </qc-dropdown-item>
                    </template>
                  </qc-dropdown-item>

                </template>
              </qc-dropdown>

              <qc-dropdown type="button" trigger="click" :closeOnClick="true" class="editor-option" minWidth="170px">
                {{endOfLine}}
                <template slot="dropdown">
                  <qc-dropdown-item @click="selectEndOfLine('LF')">LF - Unix and macOS (\n)</qc-dropdown-item>
                  <qc-dropdown-item @click="selectEndOfLine('CRLF')">CRLF - Windows (\r\n)</qc-dropdown-item>
                </template>
              </qc-dropdown>

              <qc-dropdown type="button" trigger="click" :closeOnClick="true"
                class="editor-option editor-language-dropdown" filterable>
                {{currLanguage}}
                <template slot="dropdown">
                  <qc-dropdown-item v-for="language in languageList" :key="language" @click="selectLanguage(language)"
                    :label="language">
                  </qc-dropdown-item>
                </template>
              </qc-dropdown>
            </div>

            <div class="save">
              <button class="tc-15-btn m" @click="saveFile" :class="{disabled:!unsaved}"
                :disabled="!unsaved">{{$t('core.save')}}</button>
              <button class="tc-15-btn m weak" :class="{disabled:!unsaved}"
                :disabled="!unsaved" @click="saveFileAs" >{{$t('core.saveAs')}}</button>
              <button class="tc-15-btn m weak" @click="closeDialog">{{$t('core.close')}}</button>
            </div>
          </div>
        </div>
      </div>
      <div class="editor allow-user-select" :style="{'height':`${editorRect.height}px`}">
        <template v-if="innerShow">
          <div v-if="reading" class="editor-tips">
            {{$t('core.edit_reading_file')}}{{readPercent?Math.round(readPercent*100)+'%':''}} ...
          </div>
          <div v-else-if="notAllowedEdit" class="editor-tips">
            {{errorMsg}}
            <div style="font-size:14px;margin-top:10px;">
              <a href="javascript:void(0)" @click="onStillEdit">{{$t('core.still_edit')}}</a>
            </div>
          </div>
          <div v-else-if="errorMsg" class="editor-error">{{$t('core.edit_reading_error')}} {{errorMsg}}</div>
          <div v-else ref="container" class="monaco"></div>
        </template>
      </div>

    </qc-dialog>

    <history :show.sync="historyShow"> </history>
    <!-- 未保存关闭弹窗 -->
    <exit-save :show.sync="exitSaveShow" @save="exitSaveShow=false;saveFile(true)" @unsave="closeDialog(true)" />
    <!-- 另存为重命名弹窗 -->
    <x-rename :show.sync="renameShow" :filename="fileInfo && fileInfo.key" @submit="saveFile(false, $event)"></x-rename>

  </div>

</template>

<script>
import * as monaco from 'monaco-editor';
import {
  getInnerProps,
  getuuid,
  tips,
  getFilteredHeadObjectData,
  getFileEndType,
} from '@/scripts/tools/utils';
import dialog from '@/scripts/tools/dialog';
import { config } from '@/scripts/tools/config';
import charsetUtil from '@/scripts/helper/editor/charsetUtil';
import CHARSET from '@/scripts/helper/editor/charset';
import editorTools from '@/scripts/helper/editor/tools';
import cos from '@/scripts/helper/cos';
import { getObjectMetaAndAcl } from '@/scripts/helper/cos/cosSdkUtils';

import XRename from '@/components/dialog/others/editor/rename.vue';
import exitSave from '@/components/dialog/others/editor/exitSave.vue';
import history from './history.vue';

export default {
  components: {
    history,
    exitSave,
    XRename,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false,
    },
    fileInfo: {
      type: Object,
      required: false,
    },
    bucketInfo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      exitSaveShow: false,
      historyShow: false,
      renameShow: false,

      fileBuffer: null,
      fileContent: '',
      readPercent: 0,
      writePercent: 0,
      // 界面状态
      reading: false,
      writing: false,
      unsaved: false,
      errorMsg: '',
      // 编码
      fileCharset: 'utf8',
      charset: 'utf8',
      CHARSET,
      saveCharset: ['utf8', 'utf8bom', 'gbk', 'gb2312'],
      // 换行符
      endOfLine: 'LF',
      manocoEditor: null,
      languageList: editorTools.languageList,
      currLanguage: 'javascript',
      notAllowedEdit: false,
      editorRect: {
        width: 900,
        height: 900,
      },
    };
  },
  computed: {
    innerShow: getInnerProps('show'),
  },
  watch: {
    show(val) {
      if (val) {
        this.editFile();
      }
    },
  },
  methods: {
    initData() {
      this.errorMsg = '';
      this.unsaved = false;
      this.readPercent = 0;
      this.endOfLine = 'LF';
      this.charset = 'utf8';
      this.reading = true;
      this.readTaskId = getuuid();
      this.notAllowedEdit = false;

      this.initRectRender();
    },
    initRectRender() {
      const computedWidth = Math.floor((document.body.clientWidth * 4) / 5);
      const computedheight = Math.floor((document.body.clientHeight * 4) / 5);
      this.editorRect = {
        width: Math.max(computedWidth, 900),
        height: Math.max(computedheight, 400),
      };
    },
    async resetEditor() {
      const { container } = this.$refs;
      container.innerHTML = '';
      this.currLanguage = await editorTools.getMimeType(this.fileInfo.key);

      this.manocoEditor = monaco.editor.create(container, {
        theme: 'vs',
        language: this.currLanguage,
        value: this.fileContent,
        roundedSelection: false,
        scrollBeyondLastLine: false,
        autoIndent: true,
        minimap: {
          enabled: false,
        },
      });
      this.manocoEditor.onDidChangeModelContent(() => {
        this.fileBuffer = null;
        this.resetUnsaved();
      });
      this.manocoEditor.onKeyDown(e => {
        if ((e.ctrlKey || e.metaKey) && e.keyCode === 49) {
          this.saveFile();
          e.preventDefault();
        }
      });
    },
    onStillEdit() {
      this.editFile('plaintext');
    },
    editFile(forceEditAsType) {
      if (this.fileInfo.size > config.editTextMaxSize) {
        tips.error(this.$t('error.edit_file_too_large', { num: 10 }));
        this.innerShow = false;
        return;
      }

      this.initData();

      const taskId = this.readTaskId;
      cos.setSyncUploading(this.readTaskId);

      const opt = {
        onProgress: info => {
          this.readPercent = info.percent;
        },
        TaskId: this.readTaskId,
        Key: this.fileInfo.key,
        ...this.bucketInfo,
        DataType: 'arraybuffer',
        ResponseCacheControl: 'no-cache',
      };

      const allowEdit = forceEditAsType || editorTools.getMimeType(this.fileInfo.key);
      if (!allowEdit) {
        this.reading = false;
        this.notAllowedEdit = true;
        this.errorMsg = window.lang.err('error.not_allowed_edit');
        return;
      }
      cos.getObject(opt, (err, data) => {
        cos.removeSyncUploading(taskId);
        if (!this.innerShow) return;
        this.reading = false;
        if (err) {
          let { code } = err;
          let message = '';
          if (!code && err.body) {
            const errBuffer = err.body;
            const errorXml = charsetUtil.toStr(errBuffer, 'utf8');
            [, code] = errorXml.match(/\<Code\>(.*)\<\/Code\>/);
            [, message] = errorXml.match(/\<Message\>(.*)\<\/Message\>/);
          }
          this.errorMsg = window.lang.err(`error.${code}`, message || err);
          return;
        }

        this.$nextTick(() => {
          this.fileBuffer = data.Body;
          this.fileCharset = charsetUtil.detectEncodingFromBuffer(data.Body) || 'utf8';
          this.charset = this.fileCharset;
          this.endOfLine = this.fileContent.includes('\r\n') ? 'CRLF' : 'LF';

          this.resetContent();
          this.resetEditor();
          this.fetchHeadObjectData();
          // 每次打开编辑弹窗则保存文件编辑前的历史状态
          editorTools.saveFileToLocal(opt.Key, data.Body);
        });
      });
    },
    async fetchHeadObjectData() {
      try {
        this.HeadObjectData = await getFilteredHeadObjectData(
          this.bucketInfo,
          this.fileInfo,
        );
      } catch (error) {
        // 处理错误
        console.log(error, '头部过滤失败');
      }
    },
    onEditorHistory() {
      this.historyShow = true;
    },
    resetUnsaved() {
      if (!this.manocoEditor) return;
      this.unsaved = this.manocoEditor.getValue() !== this.fileContent
        || this.charset !== this.fileCharset;
    },
    resetContent() {
      this.fileContent = charsetUtil.toStr(this.fileBuffer, this.charset);
    },
    selectEndOfLine(type) {
      if (!this.manocoEditor) return;
      let content = this.manocoEditor.getValue();
      if (type === 'CRLF') {
        content = content.replace(/\r\n|\r|\n/g, '\r\n');
      } else if (type === 'LF') {
        content = content.replace(/\r\n|\r|\n/g, '\n');
      } else if (type === 'CR') {
        content = content.replace(/\r\n|\n|\r/g, '\r');
      }
      this.endOfLine = type;
      this.manocoEditor.setValue(content);
      this.resetUnsaved();
    },
    selectLanguage(language) {
      this.currLanguage = language;
      const model = this.manocoEditor.getModel();
      monaco.editor.setModelLanguage(model, language);
    },
    openWithCharset(charset) {
      if (this.fileBuffer) {
        this.fileCharset = charset;
        this.charset = charset;
        this.resetContent();
        this.resetEditor();
      } else {
        tips.error(this.$t('error.modified_file_need_save'));
      }
    },
    saveWithCharset(charset) {
      this.charset = charset;
      this.resetUnsaved();
    },
    async checkIfCanSave({ curCharset, curContent, saveBuf }) {
      const dialogAsync = message => new Promise(resolve => {
        setTimeout(() => {
          dialog.confirm({
            title: this.$t('core.default_title'),
            message,
          }, confirm => {
            resolve(confirm);
          });
        }, 500);
      });
      let canSave = true;
      // 检查转换编码后，还能否转回来
      if (charsetUtil.toStr(saveBuf, curCharset) !== curContent) {
        const message = this.$t('error.not_support_save_as_encode_param', {
          encode: this.CHARSET[curCharset].labelShort,
        }) + this.$t('core.confirm_to_save');
        canSave = await dialogAsync(message);
      }

      if (canSave && editorTools.hasGarbled(curContent)) {
        const message = this.$t('error.content_exist_garbled', {
          encode: this.CHARSET[curCharset].labelShort,
        }) + this.$t('core.confirm_to_save');
        canSave = await dialogAsync(message);
      }

      return canSave;
    },
    async saveFile(isExit, rename) {
      if (!this.innerShow || !this.unsaved) {
        if (!rename) return;
      } else if (!this.fileInfo) {
        tips.error(this.$t('error.NoSuchKey'));
        return;
      }

      const curCharset = this.charset;
      const curContent = this.manocoEditor.getValue();
      const saveBuf = charsetUtil.toBuf(curContent, curCharset);
      const saveBlob = new Blob([saveBuf]);

      // 把内容转为保存的编码
      if (saveBuf === false) {
        console.log(`转换为 ${this.CHARSET[curCharset].labelShort} 编码失败`);
        return;
      }

      this.writing = true;
      const checkRes = await this.checkIfCanSave({
        curCharset,
        curContent,
        saveBuf,
      });
      if (!checkRes) {
        this.writing = false;
        return;
      }

      // // 仅允许保存为部分格式
      // if (!this.saveCharset.includes(curCharset)) {
      //     util.error('不支持保存为 ' + curCharset + '格式');
      //     return;
      // }
      // 兼容另存为后缀命名及content-type统一
      let headers = {};
      if (rename) {
        const fileType = getFileEndType(rename);
        headers = { ...this.HeadObjectData, 'content-type': fileType || 'application/octet-stream' };
      } else {
        headers = this.HeadObjectData;
      }
      // 保存到 COS
      const opt = {
        Body: saveBlob,
        SkipTask: true,
        Key: rename || this.fileInfo.key,
        ...this.bucketInfo,
        Headers: headers,
      };
      getObjectMetaAndAcl(opt, (err1, data) => {
        if (data) {
          const { ACL = 'default', StorageClass } = data;
          opt.ACL = ACL;
          opt.StorageClass = StorageClass;
        } else {
          opt.ACL = 'default';
        }

        cos.putObject(opt, err => {
          tips.closeTips();
          this.writing = false;
          if (err) {
            tips.error(this.$t('state.fail.save'));
          } else {
            this.fileCharset = curCharset;
            this.fileContent = curContent;
            this.fileBuffer = charsetUtil.arr2buf(saveBuf);
            !rename && this.resetUnsaved();
            tips.success(this.$t('state.success.save'));
            if (isExit === true) this.innerShow = false;
          }
        });
      });
    },
    saveFileAs() {
      this.renameShow = true;
    },
    closeDialog(forceClose) {
      const close = () => {
        this.exitSaveShow = false;
        this.innerShow = false;
        this.manocoEditor = null;
        if (this.reading) {
          cos.emit('inner-kill-task', { TaskId: this.readTaskId });
          this.reading = false;
        }
        if (this.writing) {
          cos.cancelTask('inner-kill-task', { TaskId: this.readTaskId });
          this.reading = false;
        }
        this.$emit('refresh');
      };
      if (forceClose !== true && this.unsaved) {
        this.exitSaveShow = true;
      } else {
        close();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.editor-dialog {
  .tc-15-rich-dialog-hd {
    display: none;
  }
  .header {
    padding-bottom: 10px;

    .title {
      line-height: 30px;
      display: inline-block;
      .title-text,
      .title-tips {
        display: inline-block;
        vertical-align: top;
      }

      .title-text {
        width: 250px;
        font-weight: bold;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .title-tips {
        margin-left: 10px;
        font-size: 12px;
        color: orange;
      }
    }

    .toolbar {
      float: right;
      .save,
      .setting,
      .history {
        display: inline-block;
      }
      .save button {
        padding: 0 10px;
      }
      .setting {
        margin-right: 10px;

        .editor-option {
          min-width: 1px;
          margin-right: -1px;
        }
      }
      .history {
        margin-right: 10px;
      }
    }
  }

  .editor {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 540px;
    background: #fff;
    margin-bottom: 25px;

    .editor-tips,
    .editor-error {
      flex: 1;
      position: relative;
      font-size: 18px;
      color: #999;
      text-align: center;
      padding-top: 160px;
    }

    .editor-error {
      color: red;
      font-size: 16px;
    }

    .monaco {
      flex: 1;
      width: 100%;
      position: relative;
      border: 1px solid #ddd;
      box-sizing: border-box;
    }
  }
}
</style>

<style lang="scss">
.history-bubble-index {
  z-index: 1001;
}
.editor-dialog {
  .tc-15-dropdown-link {
    line-height: 24px;
    height: 26px;
  }
}
.editor-language-dropdown .tc-15-dropdown-menu {
  max-height: 500px;
  overflow-y: auto!important;
}
.editor-double-dropdown .tc-15-dropdown-menu {
/* 让主菜单允许溢出，子菜单才能跳出来 */
  position: relative;   overflow: visible !important;
  z-index: 2000 !important;
  min-width: 180px;
  max-height: 400px;
 }

/* 子菜单绝对定位，浮在主菜单右侧 */
 .editor-double-dropdown .tc-15-dropdown-menu .tc-15-dropdown-menu {
  position: absolute !important;
  z-index: 3000 !important;
  min-width: 180px;
  max-height: 400px;
  overflow-y: auto!important;
}
</style>
